module.exports = __webpack_public_path__ + "img/az.d04ea28c.png";